import { api } from "../../gateways/unilabApi";

export async function getConnectionsGuidsByGeomGuidAndSide(payload) {
  var guid = payload.guid;
  var side = payload.side;
  return await api.get(
    `connections-plates/getConnectionsGuidsByGeomGuidAndSide?guid=${guid}&side=${side}`
  );
}
export async function postSaveConnectionPiastreBySide(payload) {
  return await api.post(`connections-plates/saveConnectionPiastreBySide`, payload);
}
